import { supabaseClient } from '@/utils/supabase-client';

/**
 * Organizations API functions
 * Pure API calls without React-specific logic
 */

export const suppliersApi = {
  /**
   * Get a supplier
   */
  getSupplier: (supplierId: string) => {
    return supabaseClient
      .from('supplier')
      .select('*, ingredient(count)')
      .eq('id', supplierId)
      .single();
  },

  /**
   * Add managed suppliers to organization
   */
  addManagedSuppliers: (
    suppliers: {
      organisation_id: string;
      supplier_id: string;
    }[],
  ) => {
    return supabaseClient
      .from('organisation_managed_supplier')
      .insert(suppliers)
      .select();
  },

  /**
   * Get all managed suppliers
   */
  getManagedSuppliers: () => {
    return (
      supabaseClient
        .from('supplier')
        // TODO: Remove the ingredient count here
        .select('*, ingredient(count)')
        .is('organisation_id', null)
    );
  },

  /**
   * Remove a managed supplier from the organization
   */
  removeManagedSupplier: (organizationId: string, supplierId: string) => {
    return supabaseClient
      .from('organisation_managed_supplier')
      .delete()
      .eq('organisation_id', organizationId)
      .eq('supplier_id', supplierId);
  },

  /**
   * Get all unmanaged suppliers for an organization
   */
  getOrganisationSuppliers: (organizationId: string) => {
    return supabaseClient
      .from('supplier')
      .select('*, ingredient(count)')
      .eq('organisation_id', organizationId);
  },

  /**
   * Get all managed suppliers for an organization
   */
  getOrganisationManagedSuppliers: (organizationId: string) => {
    return supabaseClient
      .from('organisation_managed_supplier')
      .select('*, supplier(*, ingredient(count))')
      .eq('organisation_id', organizationId);
  },

  getAllManagedSuppliers: () => {
    return supabaseClient
      .from('supplier')
      .select('*, ingredient(count)')
      .is('organisation_id', null);
  },
};
